import { TweenMax, Power0 } from 'gsap'
import { screenSizeCoefficient } from './utils/breakpoints'


let xValue = 13.75 * screenSizeCoefficient()

function playLoadMoreAnimation(element) {

    TweenMax.to($(".popup.opened .loader"), 5, {rotation:360, repeat:-1,ease: Power0.easeNone});
    playAnimationLoop()

}


function playAnimationLoop() {

  if(!$(".popup.opened .loader").length) return false


  TweenMax.set($(".popup.opened .cube_loader1"),{borderRadius:10,scale:0.7});
  TweenMax.set($(".popup.opened .cube_loader2"),{borderRadius:10,scale:0.7});
  TweenMax.set($(".popup.opened .cube_loader3"),{borderRadius:10,scale:0.7});
  TweenMax.set($(".popup.opened .cube_loader4"),{borderRadius:10,scale:0.7});

  TweenMax.to($(".popup.opened .cube_loader1"), 1, {y: xValue});
  TweenMax.to($(".popup.opened .cube_loader1"), 1, {delay:1,x: -xValue});
  TweenMax.to($(".popup.opened .cube_loader1"), 1, {delay:2,y:0});
  TweenMax.to($(".popup.opened .cube_loader1"), 1, {delay:3,x:0});
  TweenMax.to($(".popup.opened .cube_loader1"), 1, {borderRadius:50, yoyo:true, repeat:-1,ease: Power0.easeNone});
  TweenMax.to($(".popup.opened .cube_loader2"), 1, {x: xValue});
  TweenMax.to($(".popup.opened .cube_loader2"), 1, {delay:1,y: xValue});
  TweenMax.to($(".popup.opened .cube_loader2"), 1, {delay:2,x:0});
  TweenMax.to($(".popup.opened .cube_loader2"), 1, {delay:3,y:0});
  TweenMax.to($(".popup.opened .cube_loader2"), 1, {borderRadius:50, yoyo:true, repeat:-1,ease: Power0.easeNone});
  TweenMax.to($(".popup.opened .cube_loader3"), 1, {x: -xValue});
  TweenMax.to($(".popup.opened .cube_loader3"), 1, {delay:1,y: -xValue});
  TweenMax.to($(".popup.opened .cube_loader3"), 1, {delay:2,x:0});
  TweenMax.to($(".popup.opened .cube_loader3"), 1, {delay:3,y:0});
  TweenMax.to($(".popup.opened .cube_loader3"), 1, {borderRadius:50, yoyo:true, repeat:-1,ease: Power0.easeNone});
  TweenMax.to($(".popup.opened .cube_loader4"), 1, {y: -xValue});
  TweenMax.to($(".popup.opened .cube_loader4"), 1, {delay:1,x: xValue});
  TweenMax.to($(".popup.opened .cube_loader4"), 1, {delay:2,y:0});
  TweenMax.to($(".popup.opened .cube_loader4"), 1, {delay:3,x:0});
  TweenMax.to($(".popup.opened .cube_loader4"), 1, {borderRadius:50, yoyo:true, repeat:-1,ease: Power0.easeNone});


  TweenMax.to($(),1,{delay:3,onComplete:playAnimationLoop});
}
export { playLoadMoreAnimation }

